// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';

import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hooks';
import { deleteCompanyType } from '../../../../reducers/companyTypeReducer';

function DeleteCompanyType({ done, id, cancel }) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(deleteCompanyType(id))
      .then(() => {
        toast.success(t('Company type successfully deleted'));
        done();
      })
      .catch((e) => {
        toast.error(t('Failed to delete company type'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the company type')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}



export default DeleteCompanyType;
